
<div class="shop-view">
  <ftu-block
    dismiss-key="shop"
    icon="local_offer"
    title="This is the Shop"
    description="The Shop is where you can search cards for sale across multiple platforms. Use the powerful filters and sorts to find your next big purchase and save your search so you can check it quickly each day."
  />

  <page-header title="Shop">
    <template #actions>
      <align small-gap>
        <saved-filters
          v-show="!isFeedView"
          type="shop"
          :query="query"
          :filters="filters"
          :is-filtering="isFiltering"
          @select="applySavedFilter"
        />

        <icon-button
          icon="dynamic_feed"
          tooltip="View Full Feed"
          :class="{ success: isFeedView }"
          @click="isFeedView = true"
        />

        <icon-button
          v-show="isFeedView"
          icon="close"
          tooltip="Close Feed"
          @click="isFeedView = false"
        />
      </align>
    </template>
  </page-header>

  <align
    v-show="!isFeedView"
    flex
    collapse-end
    direction="flex-start"
  >
    <shared-filters
      show-recent-searches
      :sales-platforms="platformOptions"
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <align>
      <align small-gap>
        <icon-button
          icon="list"
          :class="{ success: shopViewType === 'list' }"
          @click="shopViewType = 'list'"
        />

        <icon-button
          icon="view_module"
          :class="{ success: shopViewType === 'grid' }"
          @click="shopViewType = 'grid'"
        />
      </align>

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <filter-results
    v-show="!isFeedView"
    :is-filtering="isFiltering"
    :filters="filters"
    :results="numResults && numResults < 10000 ? numResults : null"
    @clear="clearFilters"
  />

  <div class="results">
    <p class="affiliate-text">
      If you purchase an item from the results below after clicking the link, Card Ladder may be compensated at no additional cost to you.
    </p>

    <p
      v-if="isFeedView && feedCapNotice"
      class="feed-cap-notice"
    >
      {{ feedCapNotice }}
    </p>

    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      :title="isFeedView ? 'Your feed is empty' : 'There are no results for your query'"
      :description="isFeedView ? 'Make sure you have at least one saved search' : 'Try searching for something else'"
    />

    <div v-if="shopViewType === 'list'" class="list">
      <shop-list-item
        v-for="item in listings"
        :key="item.id"
        :item="item"
        as="a"
        :href="item.url"
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>

    <div v-else class="grid">
      <shop-listing-card
        v-for="item in listings"
        :key="item.id"
        :item="item"
        :href="item.url"
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>

    <infinite-scroll
      :loading="loading"
      :has-more-data="hasMoreData"
      @load="loadMore"
    />

    <scroll-top />
  </div>
</div>
